const LEVELS = {
  lvl0: 0,
  lvl1: 1,
  lvl2: 2,
  lvl3: 3,
  lvl4: 4,
}

export const getCartItemLevel = (item) => {
  const products = {
    OneTimeServiceCartItem: [{ lvl: LEVELS.lvl4 }],
    MedicalCheckCartItem: [{ lvl: LEVELS.lvl4 }],
  }
  const isShippingWithBeneficiary = item.product.shippingWithBeneficiary || false

  return products[item._typename]?.reduce((lvl, terms) => {
    if (
      (terms.isShippingWithBeneficiary ? isShippingWithBeneficiary === terms.isShippingWithBeneficiary : true) &&
      terms.lvl > lvl
    ) {
      lvl = terms.lvl
    }
    return lvl
  }, 0) || 0
}
